export const ADMIN_ESCALATION_LEVEL_FETCH = 'ADMIN_ESCALATION_LEVEL_FETCH';
export const ADMIN_ESCALATION_LEVEL_ADD = 'ADMIN_ESCALATION_LEVEL_ADD';
export const ADMIN_ESCALATION_LEVEL_EDIT = 'ADMIN_ESCALATION_LEVEL_EDIT';
export const ADMIN_ESCALATION_LEVEL_UPDATE = 'ADMIN_ESCALATION_LEVEL_UPDATE';
export const ADMIN_ESCALATION_LEVEL_REMOVE = 'ADMIN_ESCALATION_LEVEL_REMOVE';


